import { SVGProps } from 'react';

const ChartNoAxesGantt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 6h10M6 12h9m-4 6h7"
    />
  </svg>
);
export default ChartNoAxesGantt;
